import React, { useState, useEffect } from 'react';
import { Card, Form, Button, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { createPaymentMethod } from '../../services/admin';
import PageTitle from '../../Component/Comman/PageTitle';

const AddPaymentMethod = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        accountHolderName: '',
        bankName: '',
        accountNumber: '',
        ifscCode: '',
        upiId: '',
        upiQrCode: null
    });
    const [qrPreview, setQrPreview] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData(prev => ({
                ...prev,
                upiQrCode: file
            }));
            setQrPreview(URL.createObjectURL(file));
        }
    };

    const handleRemoveQrCode = () => {
        setFormData(prev => ({
            ...prev,
            upiQrCode: null
        }));
        setQrPreview('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        try {
            setLoading(true);
            
            // Create FormData object for multipart/form-data
            const data = new FormData();
            Object.keys(formData).forEach(key => {
                if (key === 'upiQrCode') {
                    if (formData[key]) {
                        data.append(key, formData[key]);
                    }
                } else {
                    // Pass whitespace for empty fields
                    data.append(key, formData[key] || ' ');
                }
            });

            const response = await createPaymentMethod(data);
            
            if (response.success) {
                alert(response.message || "Payment method added successfully");
                navigate('/admin/payment-methods');
            } else {
                throw new Error(response.message || "Failed to add payment method");
            }
        } catch (error) {
            console.error('Error adding payment method:', error);
            alert(error.message || "Failed to add payment method");
        } finally {
            setLoading(false);
        }
    };

    // Inject custom styles
    useEffect(() => {
        const addPaymentMethodStyles = `
            .form-label {
                font-weight: 500;
                color: #2c3e50;
            }
            .form-control {
                border-color: #e9ecef;
            }
            .form-control:focus {
                border-color: #3b7ddd;
                box-shadow: 0 0 0 0.2rem rgba(59, 125, 221, 0.25);
            }
        `;

        const styleId = 'add-payment-method-custom-styles';
        if (!document.getElementById(styleId)) {
            const style = document.createElement('style');
            style.id = styleId;
            style.innerHTML = addPaymentMethodStyles;
            document.head.appendChild(style);
        }
        return () => {
            const style = document.getElementById(styleId);
            if (style) {
                style.remove();
            }
        };
    }, []);

    return (
        <div className="container-xxl">
            <PageTitle pagetitle="Add Payment Method" sidebutton={false} />

            <div className="row">
                <div className="col-xl-12 col-lg-12">
                    <Card className="border-0 shadow-sm">
                        <Card.Header className="bg-white border-bottom">
                            <Card.Title className="mb-0">Add New Payment Method</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <Form onSubmit={handleSubmit}>
                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                <strong>Account Holder Name</strong>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="accountHolderName"
                                                value={formData.accountHolderName}
                                                onChange={handleChange}
                                                placeholder="Enter account holder name"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                <strong>Bank Name</strong>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="bankName"
                                                value={formData.bankName}
                                                onChange={handleChange}
                                                placeholder="Enter bank name"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                <strong>Account Number</strong>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="accountNumber"
                                                value={formData.accountNumber}
                                                onChange={handleChange}
                                                placeholder="Enter account number"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                <strong>IFSC Code</strong>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="ifscCode"
                                                value={formData.ifscCode}
                                                onChange={handleChange}
                                                placeholder="Enter IFSC code"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                <strong>Address</strong>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="upiId"
                                                value={formData.upiId}
                                                onChange={handleChange}
                                                placeholder="Enter Address"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                <strong>QR Code</strong>
                                            </Form.Label>
                                            <Form.Control
                                                type="file"
                                                accept="image/*"
                                                onChange={handleFileChange}
                                                className="mb-2"
                                            />
                                            {qrPreview && (
                                                <div className="mt-2 position-relative d-inline-block">
                                                    <img
                                                        src={qrPreview}
                                                        alt="QR Code Preview"
                                                        style={{ maxWidth: '200px', maxHeight: '200px', objectFit: 'contain', display: 'block' }}
                                                        onError={(e) => {
                                                            console.error('Image load error:', qrPreview);
                                                        }}
                                                    />
                                                    <Button
                                                        variant="danger"
                                                        size="sm"
                                                        className="position-absolute top-0 end-0 m-1"
                                                        onClick={handleRemoveQrCode}
                                                        title="Remove QR Code"
                                                    >
                                                        <i className="fa fa-times"></i>
                                                    </Button>
                                                </div>
                                            )}
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <div className="mt-3">
                                    <Button 
                                        variant="secondary" 
                                        className="me-2"
                                        onClick={() => navigate('/admin/payment-methods')}
                                        disabled={loading}
                                    >
                                        Cancel
                                    </Button>
                                    <Button 
                                        type="submit" 
                                        variant="primary"
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <>
                                                <span className="me-2">Adding...</span>
                                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            </>
                                        ) : (
                                            'Add Payment Method'
                                        )}
                                    </Button>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default AddPaymentMethod;

